<template>
  <div class="c-calendar__header">
    <div class="text-center">
      <h2 class="h5 u-color--primary u-no-margin">
        <span class="c-calendar__current-week">{{ $t('weeks.current_week')}}:</span>
        KW {{ kw }}
      </h2>
    </div>
    <div class="l-calendar-grid">
      <div class="c-calendar__day c-calendar__day--has-heading">
        <div class="c-calendar__kolonne-button">
          <router-link
            :to="{ name : 'view-crew', params: {date: startdate} }"
            class="button button--action button--action--settings button--small"
            :title="$t('weeks.kolonne.edit')"
          >{{ $t('weeks.kolonne.edit') }}</router-link>
        </div>

        <h2 class="c-calendar__heading">{{ $t('tours.kolonne')}}</h2>
      </div>
      <div
        class="c-calendar__day l-calendar-grid__cell"
        v-for="(item, index) in this.days_of_week"
        :key="index"
      >
        <strong>{{ item | moment("dd") }}</strong>
        <br />
        {{ item | moment("DD.MM.YYYY") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "WeekHeader",
  data: function() {
    return {};
  },
  props: {
    days_of_week: {
      type: Array,
      default: () => []
    },
    kolonne: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    kw: function() {
      return this.$moment(this.days_of_week[0]).format("w");
    },
    startdate: function() {
      return this.$moment(this.days_of_week[0]).format("YYYY-MM-DD");
    }
  }
};
</script>